/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState, useRef, MouseEvent } from 'react'
import { Button } from '@components/ui/Button'
import Carousel, { CarouselSlide, CarouselType } from '@components/ui/Carousel'
import TabItem, { TabItemProps } from './TabItem'
import styles from './styles.module.scss'

type NavButtonProps = {
  text: string
  extraClass: string
  currentIndex: number
  index: number
  onClick: (arg: number) => void
}

function NavButton({
  text,
  currentIndex,
  index,
  onClick,
  extraClass
}: NavButtonProps) {
  return (
    <Button
      variant={currentIndex === index ? 'primary' : 'secondary'}
      classes={`button--compare-nav ${extraClass || ''} ${
        styles.lightboxNavButton
      }`}
      onClick={() => onClick(index)}
      fullWidth="always"
    >
      {text}
    </Button>
  )
}

type TabsProps = {
  title: string
  byline?: string
  extraClass: string
  data: readonly Omit<TabItemProps, 'extraClass'>[]
}

function Tabs({ data, title, byline, extraClass }: TabsProps) {
  const [currentIndex, setCurrentIndex] = useState(0)
  const carouselRef = useRef<CarouselType>()

  const handleOutSideClick = (e: MouseEvent) => {
    e.stopPropagation()
  }

  const onCurrentChange = (value: number) => {
    carouselRef.current?.scrollTo(value)
    setCurrentIndex(value)
  }

  const settings = {
    dots: true,
    slidesToScroll: 1,
    startIndex: 0,
    loop: true,
    afterChange: (current: number) => {
      onCurrentChange(current)
    }
  }

  return (
    <div className="modal__content" onClick={handleOutSideClick}>
      <div className={`${styles.lightbox__column} ${extraClass || ''}`}>
        <h3 className={`${styles.lightbox__title} ${extraClass || ''}`}>
          {title}
        </h3>
        {byline && (
          <p className={`${styles.lightbox__byline} ${extraClass || ''}`}>
            {byline}
          </p>
        )}
        <nav className={`${styles.lightboxContent__nav} ${extraClass || ''}`}>
          {data.map((item, i) => (
            <NavButton
              key={`lightboxContent-button-${i}`}
              text={`${item.text}`}
              index={i}
              currentIndex={currentIndex}
              onClick={onCurrentChange}
              extraClass={extraClass}
            />
          ))}
        </nav>
        <div className={`${styles.lightboxContent} ${extraClass || ''}`}>
          <Carousel
            carouselDotsClasses={styles.carousel__dots}
            instance={instance => {
              carouselRef.current = instance
            }}
            settings={settings}
          >
            {data.map((item, i) => (
              <CarouselSlide key={`lightboxContent-${i}`}>
                <TabItem {...item} extraClass={extraClass} />
              </CarouselSlide>
            ))}
          </Carousel>
        </div>
      </div>
    </div>
  )
}

export default Tabs
